export const DEX_LP_TRADE_WIDGET_TYPE_ID = 'DexLpTradeWidget';
